import { useMutation, useQueryClient } from "@tanstack/react-query"
import { postAuthSignIn } from "~/features/sign-in/queries/auth"
import { saveJWTToken } from "~/shared/utils/jwt-token"

const useSignInMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: postAuthSignIn,
    onSuccess: async (res) => {
      const { accessToken, refreshToken } = res.data

      saveJWTToken({ accessToken, refreshToken })

      queryClient.invalidateQueries()
    },
    onError: (error) => {
      throw error
    },
  })
}

export default useSignInMutation
